export default {
    access_denied: "Access denied",
    filter_placeholder: "Filter by Establishment Name",
    add_place: "Add Establishment",
    edit_place: "Edit Establishment",
    form: {
        logo: "Logo",
        logo_title: "Establishment Logo",
        name: "Name",
        name_title: "Establishment Name",
        slug: "Slug",
        slug_title: "Establishment Slug",
        address: "Address",
        address_title: "Establishment Address",
        address_2: "Complement",
        address_2_title: "Establishment Address Complement",
        zone: "Neighborhood",
        zone_title: "Establishment Neighborhood",
        city: "City",
        city_title: "Establishment City",
        state: "State",
        state_title: "Establishment State",
        zip_code: "Postal Code (CEP)",
        zip_code_title: "Establishment Postal Code",
        phone: "Phone",
        phone_title: "Establishment Phone",
        phone_placeholder: "(##) #####-####",
        legal_name: "Legal Name",
        legal_name_title: "Establishment Legal Name",
        tax_id: "Tax ID",
        tax_id_title: "Establishment Tax ID",
        email: "Email",
        email_title: "Establishment Email",
        color: "Color",
        color_title: "Establishment Color",
        color_placeholder: "FFFFFF",
        timezone: "Time zone",
        timezone_title: "Establishment time zone",
        country: "Country",
        country_title: "Establishment Country",
        currency: "Currency",
        currency_title: "Establishment Currency",
        credits_per_month: "SMS credits per month",
        credits_per_month_title: "Establishment Credit",
        modules: "Modules",
        modules_helper: "Select one or more modules",
        modules_title: "Establishment Modules",
        none: "None",
        all: "All",
        copy_automations_from: "Copy Automations From:",
        kevi_marketing: "Access to Kevi Marketing",
        kevi_chat: "Access to Kevi Chat",
        yes: "Yes",
        no: "No",
        save: "Save",
        notification: {
            fill_fields: "Warning! Fill in all fields correctly.",
            saved: "Data saved successfully!",
            updated: "Establishment updated successfully!",
            update_error: "Error updating the establishment.",
            load_error: "Error loading establishment data.",
        },
        validation: {
            logo_required: "The logo is required.",
            name_required: "The name is required.",
            slug_required: "The slug is required.",
            slug_format:
                "The slug can only contain lowercase letters, numbers, and -. Maximum of 20 characters.",
            address_required: "The address is required.",
            address_2_required: "The complement is required.",
            zone_required: "The neighborhood is required.",
            city_required: "The city is required.",
            state_required: "The state is required.",
            zip_code_required: "The postal code is required.",
            phone_required: "The phone is required.",
            phone_format:
                "Enter a valid phone number for the selected country.",
            color_required: "The color is required.",
            color_format:
                "The color must be in hexadecimal format (e.g. FFFFFF).",
            credits_per_month_required:
                "SMS credits per month are required.",
            credits_per_month_positive:
                "SMS credits per month must be a positive number.",
            modules_required: "Select at least one module.",
            legal_name_required: "The legal name is required.",
            tax_id_required: "The tax ID is required.",
            email_required: "The email is required.",
            email_format: "Please enter a valid email.",
            plan_required: "The plan is required.",
            change_reason_required: "Change reason is required.",
        },
        states: {
            AC: "Acre",
            AL: "Alagoas",
            AP: "Amapa",
            AM: "Amazonas",
            BA: "Bahia",
            CE: "Ceara",
            DF: "Federal District",
            ES: "Espirito Santo",
            GO: "Goias",
            MA: "Maranhao",
            MT: "Mato Grosso",
            MS: "Mato Grosso do Sul",
            MG: "Minas Gerais",
            PA: "Para",
            PB: "Paraiba",
            PR: "Parana",
            PE: "Pernambuco",
            PI: "Piaui",
            RJ: "Rio de Janeiro",
            RN: "Rio Grande do Norte",
            RS: "Rio Grande do Sul",
            RO: "Rondonia",
            RR: "Roraima",
            SC: "Santa Catarina",
            SP: "Sao Paulo",
            SE: "Sergipe",
            TO: "Tocantins",
        },
        countries: {
            BR: "Brazil",
            US: "United States",
            CA: "Canada",
            AR: "Argentina",
            UY: "Uruguay",
            PY: "Paraguay",
            CL: "Chile",
            CO: "Colombia",
            PE: "Peru",
            MX: "Mexico",
            PT: "Portugal",
            ES: "Spain",
            FR: "France",
            DE: "Germany",
            IT: "Italy",
            GB: "United Kingdom",
        },
        currencies: {
            BRL: "Brazilian Real",
            USD: "US Dollar",
            CAD: "Canadian Dollar",
            EUR: "Euro",
            ARS: "Argentine Peso",
            UYU: "Uruguayan Peso",
            PYG: "Paraguayan Guarani",
            CLP: "Chilean Peso",
            COP: "Colombian Peso",
            PEN: "Peruvian Sol",
            MXN: "Mexican Peso",
            GBP: "Pound Sterling",
        },
    },
    branch_form: {
        title: "Add Branch",
        title_label: "Title",
        title_title: "Branch Title",
        address: "Address",
        address_title: "Branch Address",
        address_2: "Complement",
        zone: "Neighborhood",
        city: "City",
        city_title: "Branch City",
        state: "State",
        state_title: "Branch State",
        country: "Country",
        country_title: "Branch Country",
        zip_code: "Postal Code",
        zip_code_title: "Branch Postal Code",
        phone: "Phone",
        phone_title: "Branch Phone",
        phone_placeholder: "(##) #####-####",
        active: "Active",
        active_title: "Branch status",
        email: "Email",
        email_title: "Branch Email",
        whatsapp: "WhatsApp",
        no_whatsapp_instance: "No linked instance",
        cancel: "Cancel",
        confirm: "Confirm",
        yes: "Yes",
        no: "No",
        notification: {
            fill_fields: "Warning! Fill in all fields correctly.",
            saved: "Branch saved successfully!",
        },
        validation: {
            title_required: "The title is required.",
            address_required: "The address is required.",
            city_required: "The city is required.",
            state_required: "The state is required.",
            zip_code_required: "The postal code is required.",
            active_required: "Active is required.",
            email_valid: "The email must be valid.",
            phone_required: "The phone is required.",
            phone_format:
                "Enter a valid phone number for the selected country.",
        },
    },
    user_form: {
        title: "Add user",
        name: "Name",
        name_title: "User Name",
        email: "Email",
        email_title: "User Email",
        whatsapp: "WhatsApp",
        no_whatsapp_instance: "No linked instance",
        global_admin: "Global Administrator",
        global_admin_title: "User Permission",
        global_admin_warning:
            "This user will have access to all Kevi establishments.",
        is_internal: "Internal Kevi Use",
        is_internal_title: "Internal Kevi Use",
        active: "Active",
        active_title: "User Activity",
        branch: "Branch",
        branch_title: "User Branch",
        roles: "Roles",
        username: "Username",
        username_title: "User Username",
        password: "Password",
        password_title: "User Password",
        kevi_marketing_enabled: "Kevi Marketing Access",
        kevi_marketing_enabled_title: "Allows login and use of Kevi Marketing",
        kevi_chat_enabled: "Kevi Chat Access",
        kevi_chat_enabled_title: "Allows login and use of Kevi Chat",
        kevi_presence: "Product presence",
        kevi_presence_hint_marketing_only:
            "To link to Kevi Chat, set «Kevi Chat Access» to Yes above and save the user.",
        presence_both: "Kevi Marketing and Kevi Chat",
        presence_marketing: "Kevi Marketing only",
        presence_chat: "Kevi Chat only",
        presence_none: "No product access",
        permissions: "Permissions",
        cancel: "Cancel",
        confirm: "Confirm",
        yes: "Yes",
        no: "No",
        notification: {
            fill_fields: "Warning! Fill in all fields correctly.",
            saved: "User saved successfully!",
        },
        permission: {
            dashboard: "Dashboard",
            dashboard_help: "Accesses the dashboard and POS operations.",
            inbox: "Inbox",
            inbox_help: "Accesses customer conversations and messages.",
            tasks: "Tasks",
            tasks_help: "Accesses and manages team tasks.",
            coupons: "Coupons",
            coupons_help: "Accesses coupon creation and management.",
            clients: "Clients",
            clients_help: "Accesses the customer base and their data.",
            segments: "Segments",
            segments_help: "Accesses segment creation and management.",
            rewards: "Rewards",
            rewards_help: "Accesses the rewards program.",
            reports: "Reports",
            reports_help: "Accesses product metrics and reports.",
            forms: "Forms",
            forms_help: "Accesses forms and responses.",
            automations: "Automations",
            automations_help: "Accesses automation creation and management.",
            balance: "SMS Credits",
            balance_help: "Accesses SMS credit balance and usage.",
            configs: "Settings",
            configs_help: "Accesses establishment settings.",
            quotations: "Quotations",
            quotations_help: "Accesses quotations and proposals.",
            mcp: "MCP",
            mcp_help: "Accesses MCP and agent integrations.",
            invoices: "Invoices",
            invoices_help: "Accesses plan invoices and charges.",
            benefit_programs: "Benefits Center",
            benefit_programs_help: "Accesses the Benefits Center.",
            access_operations: "Which operations can the user access?",
            access_tasks: "Which tasks can the user access?",
            access_quotations: "Which quotations can the user access?",
            global_access: "Has access to data from all branches",
            delete_clients: "Can delete clients",
            dashboard_access_title: "Dashboard operations",
            tasks_access_title: "User Task Access",
            quotations_access_title: "User Quotation Access",
            level_insert: "Insert",
            level_read: "Read",
            scope_mine: "Own",
            scope_mine_plural: "Own",
            scope_branch: "Branch",
            scope_all_feminine: "All",
            scope_all_plural: "All",
        },
        validation: {
            name_required: "The name is required.",
            name_min_length: "The name must have at least 3 characters.",
            email_required: "The email is required.",
            email_valid: "The email must be valid.",
            email_taken: "This email is already in use.",
            password_required: "The password is required.",
            password_min_length:
                "The password must have at least 6 characters.",
            permissions_required: "The permission is required.",
            is_internal_required: "Internal use is required.",
            active_required: "Active is required.",
            branch_required: "The branch is required.",
            username_required: "The username is required.",
            username_min_length:
                "The username must have at least 3 characters.",
            username_taken: "This username is already in use.",
            tasks_access_required: "User task access is required.",
            quotations_access_required: "User quotation access is required.",
            dashboard_access_required: "POS operations are required.",
        },
    },
    plan: {
        title: "Plan ({0})",
        billing_type: "Billing type",
        billing_type_prepaid: "Prepaid",
        billing_type_postpaid: "Postpaid",
        base_fee: "Base fee",
        incentivized_revenue_share: "% Of incentivized revenue",
        retention_revenue_share: "% Of retention revenue",
        pricetable_clients: "Client price table",
        pricetable_credits: "Credits price table",
        pricetable_extra_credits: "Extra credits price table",
        included_integrations: "Included integrations",
        price_per_integration: "Price per extra integration",
        included_branches: "Included branches",
        price_per_branch: "Price per branch",
        included_users: "Included users",
        price_per_user: "Price per user",
        save: "Save",
        notification: {
            saved: "Plan updated successfully",
            no_changes: "No changes detected.",
            change_reason_required: "Please provide the reason for the change before saving.",
        },
    },
    // Details section
    details: {
        access_denied: "Access denied",
        activate: "Activate",
        activate_automations: "Activate automations",
        automations_locked: "Automations locked",
        automations_off: "Automations off",
        automations_on: "Automations on",
        block: "Block",
        deactivate_automations: "Deactivate automations",
        edit_info: "Edit information",
        manage_plan: "Manage plan",
        place_activated: "Place activated",
        place_blocked: "Place blocked",
        view_as: "View as",
    },
    // Branches section
    branches: {
        add_branch: "Add branch",
        neighborhood_city: "Neighborhood/City",
        title: "Branches",
        main_place_badge: "Main",
    },
    // Modules section
    modules: {
        title: "Modules",
        updated: "Modules updated",
    },
    // Products section
    products: {
        title: "Kevi Products",
        updated: "Products updated",
        at_least_one: "At least one product must remain enabled.",
        update_error: "Error updating products.",
        names: {
            1: "Kevi Marketing",
            2: "Kevi Chat",
        },
    },
    // Plugins section
    plugins: {
        add_plugin: "Add plugin",
        choose_plugin: "Choose plugin",
        created_at: "Created at",
        external_id: "External ID",
        settings_updated: "Settings updated",
        title: "Plugins",
    },
    // Roles section
    roles: {
        new_role_placeholder: "Enter new role name",
        role_added: "Role added",
        role_deleted: "Role deleted",
        role_updated: "Role updated",
        title: "Roles",
    },
    // Users section
    users: {
        active: "Active users",
        add_user: "Add user",
        title: "Users",
    },
    selected: "Selected",
    view_as: "View as",
    no_places_found: "No Establishments found",
    usage_report: {
        title: "Usage Report",
        general: "General",
        establishment: "Establishment",
        orders: "Orders",
        total_income: "Total income",
        new_clients: "New clients",
        sign_ups: "Sign-ups",
        sign_up_rate: "Sign-up rate",
        used_coupons: "Used coupons",
        used_rewards: "Used rewards",
        date: "Date",
        empty: "There is not enough data for the period",
    },
    email_generator: {
        title: "Email Generator",
        placeholder: "default",
    },
};
